if(!customElements.get('size-guide')) {
  class SizeGuide extends HTMLElement {
    constructor() {
      super();
      this.target = document.querySelector('.js-modal-content');
    }

    destroy() {
      this.innerHTML = '';
      this.parentNode.removeChild(this);
    }

    connectedCallback() {
      return;
    }
  }

  customElements.define('size-guide', SizeGuide);
}